import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, DOCUMENT, ElementRef, OnDestroy, OnInit, ViewChild, inject } from '@angular/core';
import { StarRatingComponent } from 'src/app/components/star-rating/star-rating.component';
import { IMAGE_URLS } from 'src/app/core/constants/image-source';
import { BrowserApiService } from 'src/app/core/services/browser-api/browser-api.service';
import { MyOverlayRef } from 'src/app/core/services/overlay/myoverlay-ref';
import { ReviewInterpolationPipe } from 'src/app/shared/pipes/review-interpolation.pipe';
import { SafeHtmlPipe } from 'src/app/shared/pipes/safe-html.pipe';

@Component({
  standalone: true,
  selector: 'webstore-google-review-overlay',
  templateUrl: './google-review-overlay.component.html',
  styleUrls: ['./google-review-overlay.component.scss'],
  imports: [
    CommonModule,
    StarRatingComponent,
    ReviewInterpolationPipe,
    SafeHtmlPipe
  ]
})
export class GoogleReviewOverlayComponent implements OnInit, AfterViewInit, OnDestroy {
  ref = inject<MyOverlayRef<GoogleReviewOverlayComponent, {
    review: any;
    reviews: any;
    baseHtml: string;
    sectionId: string;
    averagerating?: number;
    totalreviewcount?: number;
    google_reviews_page_url?: string;
  }>>(MyOverlayRef);
  private document = inject<Document>(DOCUMENT);
  private browserApiService = inject(BrowserApiService);

  @ViewChild('reviewInfo', { static: true }) reviewInfo!: ElementRef;
  IMAGE_URLS = IMAGE_URLS;
  review: any;
  reviews: any;
  baseHtml = "";
  sectionId = "";
  averagerating?: number;
  totalreviewcount?: number;
  google_reviews_page_url?: string;
  isUrlAvailable = false;

  ngOnInit(): void {
    this.review = this.ref.data.review;
    this.reviews = this.ref.data.reviews;
    this.baseHtml = this.ref.data.baseHtml;

    this.sectionId = this.ref.data.sectionId;
    this.averagerating = this.ref.data.averagerating;
    this.totalreviewcount = this.ref.data.totalreviewcount;
    this.google_reviews_page_url = this.ref.data.google_reviews_page_url;

    this.isUrlAvailable = !this.google_reviews_page_url;
    // Disable body scroll when overlay is opened
    this.document.body.style.overflow = 'hidden';
  }

  ngAfterViewInit(): void {

    const sections = this.reviewInfo?.nativeElement?.getElementsByTagName('section');
    for (let i = 0; i < sections.length; i++) {
      sections[i].id = this.sectionId;
      sections[i].classList.add(`style-${this.sectionId}`);

    }

  }

  ngOnDestroy(): void {
    // Re-enable body scroll when overlay is closed
    this.document.body.style.overflow = '';
  }

  openGoogleReviewPage() {
    if (!this.google_reviews_page_url) {
      return;
    }

    this.browserApiService.open(this.google_reviews_page_url, '_blank');
  }

}
